import { render, staticRenderFns } from "./FormalSector.vue?vue&type=template&id=82d3c1b2&scoped=true&"
import script from "./FormalSector.vue?vue&type=script&lang=js&"
export * from "./FormalSector.vue?vue&type=script&lang=js&"
import style0 from "./FormalSector.vue?vue&type=style&index=0&id=82d3c1b2&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "82d3c1b2",
  null
  
)

export default component.exports